import React, { Component } from "react";
import NewTournamentStepper from "../components/NewTournamentStepper";
import { withRouter } from "react-router-dom";
import { validateEmail } from "../util/ValidateEmail";
import { languages } from "../constants/languages";
import moment from "moment-timezone";
import ReactPixel from "react-facebook-pixel";
import { getCookieConsentValue } from "react-cookie-consent";

class NewTournamentContainer extends Component {
  state = {
    days: [],
    daysByKey: {},
    daysLoaded: false,
    sportParks: [],
    sportParksByKey: {},
    sportParksLoaded: false,
    firstName: "",
    nameClubCompany: "",
    email: "",
    password: "",
    errorMessageRegister: "",
    signingUp: false,
    userData: {},
    userDataLoaded: false,
  };

  handleOnlineCheck = (e) => {
    let online = this.props.tournament.online || false;
    let toUpdate = { online: !online };
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  validateRegistrationForm = () => {
    return validateEmail(this.state.email) && this.state.password.length > 5;
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleSignup = () => {
    let domain =
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] || "";

    if (!this.state.signingUp) {
      this.setState({ signingUp: true });
      if (this.validateRegistrationForm()) {
        var credential = window.firebase.auth.EmailAuthProvider.credential(
          this.state.email,
          this.state.password
        );
        window.firebase
          .auth()
          .currentUser.linkAndRetrieveDataWithCredential(credential)
          .then((user) => {
            let consent = getCookieConsentValue();
            if (consent === "true") {
              ReactPixel.init("802314050594771");
              ReactPixel.track("CompleteRegistration", {});
            }

            window.firebase
              .database()
              .ref("newUsers/" + user.user.uid)
              .set({
                name: this.state.nameClubCompany,
                email: this.state.email,
                registeredOn: moment().unix(),
                language: languages.getLanguage(),
                fromPSDCode: this.props.psdCode ? true : false,
              });

            const db = window.firebase.firestore();
            let batch = db.batch();
            batch.set(db.collection("users").doc(user.user.uid), {
              firstName: this.state.firstName,
              name: this.state.nameClubCompany,
              email: this.state.email.toLowerCase(),
              timezone: moment.tz.guess() || "",
              registeredOn: moment().unix(),
              registeredDomain: domain,
              registeredLang: languages.getLanguage(),
              prm: this.props.tournament.prm || false,
            });
            if (!this.props.tournament.iResCode) {
              batch.update(
                db.collection("tournaments").doc(this.props.tournament[".key"]),
                { new: false, timezone: moment.tz.guess() || "" }
              );
            }
            batch.commit();
            if (window.firebase.analytics) {
              window.firebase.analytics().logEvent("sign_up", {
                method: "email",
              });
            }
            if (this.props.psdCode) {
              this.props.history.push(
                "/tournament/" +
                  this.props.tournament[".key"] +
                  "/prosoccerdata"
              );
            } else if (this.props.tournament.iResCode) {
              fetch("https://tournify-server.herokuapp.com/checkIResCode2", {
                method: "POST",
                mode: "cors",
                headers: {
                  Accept: "application/json, text/plain, */*",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  iResCode: this.props.tournament.iResCode,
                  tournamentId: this.props.tournament[".key"],
                }),
              })
                .then(function (response) {
                  return response.json();
                })
                .then(
                  function (payload) {
                    let valid = payload.valid || false;
                    if (valid === "used") {
                      window.firebase
                        .firestore()
                        .collection("tournaments")
                        .doc(this.props.tournament[".key"])
                        .update({
                          new: false,
                          timezone: moment.tz.guess() || "",
                          iResCode: null,
                        });
                    } else {
                      window.firebase
                        .firestore()
                        .collection("tournaments")
                        .doc(this.props.tournament[".key"])
                        .update({
                          new: false,
                          timezone: moment.tz.guess() || "",
                        });
                    }
                  }.bind(this)
                );
              this.props.history.push(
                "/tournament/" + this.props.tournament[".key"] + "/teams"
              );
            } else {
              this.props.history.push(
                "/tournament/" + this.props.tournament[".key"] + "/teams"
              );
            }
            this.props.setAuthListener && this.props.setAuthListener();
          })
          .catch(
            function (error) {
              // Handle Errors here.
              // var errorCode = error.code;
              var errorMessage = error.message;
              this.setState({
                errorMessageRegister: errorMessage,
                signingUp: false,
              });
            }.bind(this)
          );
      } else {
        let errorMessage = languages.login.allFieldsRequired;
        if (!validateEmail(this.state.email)) {
          errorMessage = languages.login.invalidEmail;
        } else if (this.state.password.length < 6) {
          errorMessage = languages.login.passwordTooShort;
        }
        this.setState({ errorMessageRegister: errorMessage, signingUp: false });
      }
    }
  };

  handleNameChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleLocationChange = (e) => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let name = e.target.value;
    let sportParkDoc = tournamentRef.collection("sportParks").doc("0");
    sportParkDoc.set({ name: name, gId: null, placeId: null, reference: null });
  };

  setLocationName = (newValue) => {
    let value = newValue || {};
    let name = value.description || "";
    let id = value.id || null;
    let placeId = value.place_id || null;
    let reference = value.reference || null;

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let sportParkDoc = tournamentRef.collection("sportParks").doc("0");
    sportParkDoc.set({
      name: name,
      gId: id,
      placeId: placeId,
      reference: reference,
    });
  };

  createDefaultLocation = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let name = "";
    let sportParkDoc = tournamentRef.collection("sportParks").doc("0");
    sportParkDoc.set({ name: name });
  };

  handleDivisionChange = (e) => {
    const divisionsRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("divisions");
    let divisionDoc = divisionsRef.doc("0");
    divisionDoc.set({ name: e.target.value });
  };

  handleDateChange = (date) => {
    let toUpdate = {};
    toUpdate["date"] = date
      .tz((this.state.userData || {}).timezone || "Europe/Amsterdam")
      .unix();
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleBack = () => {
    this.props.history.push("/");
  };

  handleFinish = () => {
    if (this.props.user.isAnonymous) {
      this.handleSignup();
    } else {
      if (!this.props.tournament.iResCode) {
        window.firebase
          .firestore()
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .update({
            new: false,
            timezone: this.state.userData.timezone || "Europe/Amsterdam",
          });
      }
      if (this.props.psdCode) {
        this.props.history.push(
          "/tournament/" + this.props.tournament[".key"] + "/prosoccerdata"
        );
      } else if (this.props.tournament.iResCode) {
        fetch("https://tournify-server.herokuapp.com/checkIResCode2", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            iResCode: this.props.tournament.iResCode,
            tournamentId: this.props.tournament[".key"],
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(
            function (payload) {
              let valid = payload.valid || false;
              if (valid === "used") {
                window.firebase
                  .firestore()
                  .collection("tournaments")
                  .doc(this.props.tournament[".key"])
                  .update({
                    new: false,
                    timezone:
                      this.state.userData.timezone || "Europe/Amsterdam",
                    iResCode: null,
                  });
              } else {
                window.firebase
                  .firestore()
                  .collection("tournaments")
                  .doc(this.props.tournament[".key"])
                  .update({
                    new: false,
                    timezone:
                      this.state.userData.timezone || "Europe/Amsterdam",
                  });
              }
            }.bind(this)
          );
        this.props.history.push(
          "/tournament/" + this.props.tournament[".key"] + "/teams"
        );
      } else {
        this.props.history.push(
          "/tournament/" + this.props.tournament[".key"] + "/teams"
        );
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let days = [];
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          days.push(day);
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          days: days.sort((a, b) => a.date - b.date),
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });

    this.unsubscribeSportparks = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("sportParks")
      .onSnapshot((querySnapshot) => {
        let sportParks = [];
        let sportParksObj = {};
        querySnapshot.forEach((doc) => {
          let sportPark = doc.data();
          sportPark["id"] = doc.id;
          sportParks.push(sportPark);
          sportParksObj[doc.id] = sportPark;
        });
        this.setState({
          sportParks: sportParks.sort((a, b) => a.id - b.id),
          sportParksByKey: sportParksObj,
          sportParksLoaded: true,
        });
      });

    this.unsubscribeUser = window.firebase
      .firestore()
      .collection("users")
      .doc(this.props.user.uid)
      .onSnapshot((doc) => {
        let userData = doc.data();
        this.setState({
          userData: userData || {},
          userDataLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribeDays();
    this.unsubscribeSportparks();
    this.unsubscribeUser();
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        {this.state.userDataLoaded && (
          <NewTournamentStepper
            tournament={this.props.tournament}
            date={this.props.tournament.date}
            invalidName={this.state.invalidName}
            handleDateChange={this.handleDateChange}
            handleCreate={this.handleCreate}
            handleNameChange={this.handleNameChange}
            handleBack={this.handleBack}
            days={this.state.days}
            sportParks={this.state.sportParks}
            sportParksByKey={this.state.sportParksByKey}
            handleLocationChange={this.handleLocationChange}
            divisions={this.props.divisions}
            divisionsObject={this.props.divisionsObject}
            handleDivisionChange={this.handleDivisionChange}
            handleFinish={this.handleFinish}
            user={this.props.user}
            userStatus={this.props.userStatus}
            tournamentStatus={this.props.tournamentStatus}
            firstName={this.state.firstName}
            nameClubCompany={this.state.nameClubCompany}
            email={this.state.email}
            password={this.state.password}
            errorMessageRegister={this.state.errorMessageRegister}
            handleChange={this.handleChange}
            createDefaultLocation={this.createDefaultLocation}
            setLocationName={this.setLocationName}
            psdCode={this.props.psdCode}
            handleOnlineCheck={this.handleOnlineCheck}
            timezone={this.state.userData.timezone || "Europe/Amsterdam"}
          />
        )}
      </div>
    );
  }
}

export default withRouter(NewTournamentContainer);
